import Hero from "@/components/sections/Hero";
import DorProposito from "@/components/sections/DorProposito";
import Etapas from "@/components/sections/Etapas";
import OQueEncontra from "@/components/sections/OQueEncontra";
import Profissionais from "@/components/sections/Profissionais";
import Conteudos from "@/components/sections/Conteudos";
import CapturaLeads from "@/components/sections/CapturaLeads";
import Fornecedores from "@/components/sections/Fornecedores";
import Confianca from "@/components/sections/Confianca";
import Seo from "@/components/Seo";

const Home = () => {
  return (
    <main data-testid="home-page" className="overflow-x-hidden">
      <Seo
        path="/"
        title=""
        description="Conteúdos organizados, orientações práticas e profissionais para apoiar famílias do planejamento ao pós-parto."
      />
      <Hero />
      <DorProposito />
      <Etapas />
      <OQueEncontra />
      <Profissionais />
      <Conteudos />
      <CapturaLeads />
      <Fornecedores />
      <Confianca />
    </main>
  );
};

export default Home;
